import type { FaireProductEntity } from "../../entity_types/product";

export const p_vwqhzqsz2s: FaireProductEntity = {
  token: "p_vwqhzqsz2s",
  type: "product",
  name: "Copper Wire Wrapped Crystal Pendants - Handmade, Boho Chic Artisan Jewelry - Wholesale",
  brandToken: "b_gvkc6qnpt8",
  brandName: "Handmade Jewels",
  imageUrl:
    "https://cdn.faire.com/fastly/d3bd338ff74af4853c7694d91ff23e022fb94b49a22b9361fb57a1842f008b9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a536b7e9befc2548c9cae614217ea1cab3a35f1b93807bafdbf91504f25435d.jpeg",
    "https://cdn.faire.com/fastly/e5d0d379259d7d730d20a1fbd88b69592b7d1eca58fa0b4193ec8c0f259ad2d2.jpeg",
  ],
  priceDollars: 152.41,
  description:
    "\n\n• Handmade Artistry: Meticulously handcrafted pendants with intricate copper wirework from Silversmiths in India in our in-house Lapidary.\n\n• Natural Crystals: Set with genuine, raw, and polished gemstones in unique designs.\n\n• Wholesale Options: Available in packs of 10, 20, 50, 100, or 500 pendants for bulk buyers.\n\n• Exclusive Selection: Each pendant boasts a distinct bohemian and artisanal aesthetic.\n\n• Perfect for Resale: A versatile addition to any jewelry retailer’s collection, from boho to minimalist styles.\n\n\n\n",
  tags: [],
  msrpDollars: 304.82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:40.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
